import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    loadCount: 5,
    catalogs: {},
    projects: {},
    clients: {},
    options: {},
    pages: {}
  },
  mutations: {
    SET_LOAD_COUNT (state) {
      state.loadCount += -1
    },
    SET_LOADING_TRUE (state) {
      state.loading = true
    },
    SET_LOADING_FALSE (state) {
      state.loading = false
    },
    SET_CATALOGS (state, data) {
      state.catalogs = data
    },
    SET_PROJECTS (state, data) {
      state.projects = data
    },
    SET_CLIENTS (state, data) {
      state.clients = data
    },
    SET_OPTIONS (state, data) {
      state.options = data
    },
    SET_PAGES (state, data) {
      state.pages = data
    }
  },
  getters: {
    getItemById: (state) => (type, id) => {
      if (!state.loading) {
        switch (type) {
          case 'catalog':
            return state.catalogs.find(item => item.id === id)
          case 'project':
            return state.projects.find(item => item.id === id)
          case 'client':
            return state.clients.find(item => item.id === id)
          case 'page':
            return state.pages.find(item => item.id === id)
          default:
        }
      }
    },
    getItemBySlug: (state) => (type, slug) => {
      if (!state.loading) {
        switch (type) {
          case 'catalog':
            return state.catalogs.find(item => item.slug === slug)
          case 'project':
            return state.projects.find(item => item.slug === slug)
          case 'client':
            return state.clients.find(item => item.slug === slug)
          case 'page':
            return state.pages.find(item => item.slug === slug)
          default:
        }
      }
    },
    getProjects: (state) => (ids) => {
      let projects = state.projects.filter(function (project) {
        if (ids.includes(project.id)) {
          return project
        }
      })
      return projects
    }
  },
  actions: {
    fetchCatalogs (context) {
      context.commit('SET_LOADING_TRUE')
      return new Promise((resolve, reject) => {
        axios
          .get('https://blog.zee.nl/wp-json/wp/v2/catalogs?_embed')
          .then(response => {
            context.commit('SET_CATALOGS', response.data)
          })
          .catch(e => {
            reject(e)
          })
          .finally(x => {
            context.commit('SET_LOADING_FALSE')
            context.commit('SET_LOAD_COUNT')
          })
      })
    },
    fetchClients (context) {
      context.commit('SET_LOADING_TRUE')
      return new Promise((resolve, reject) => {
        axios
          .get('https://blog.zee.nl/wp-json/wp/v2/clients?orderby=title&order=asc&_embed')
          .then(response => {
            context.commit('SET_CLIENTS', response.data)
          })
          .catch(e => {
            reject(e)
          })
          .finally(x => {
            context.commit('SET_LOADING_FALSE')
            context.commit('SET_LOAD_COUNT')
          })
      })
    },
    fetchProjects (context) {
      context.commit('SET_LOADING_TRUE')
      return new Promise((resolve, reject) => {
        axios
          .get('https://blog.zee.nl/wp-json/wp/v2/projects?_embed')
          .then(response => {
            context.commit('SET_PROJECTS', response.data)
          })
          .catch(e => {
            reject(e)
          })
          .finally(x => {
            context.commit('SET_LOADING_FALSE')
            context.commit('SET_LOAD_COUNT')
          })
      })
    },
    fetchOptions (context) {
      context.commit('SET_LOADING_TRUE')
      return new Promise((resolve, reject) => {
        axios
          .get('https://blog.zee.nl/wp-json/wp/v2/options')
          .then(response => {
            context.commit('SET_OPTIONS', response.data)
          })
          .catch(e => {
            reject(e)
          })
          .finally(x => {
            context.commit('SET_LOADING_FALSE')
            context.commit('SET_LOAD_COUNT')
          })
      })
    },
    fetchPages (context) {
      context.commit('SET_LOADING_TRUE')
      return new Promise((resolve, reject) => {
        axios
          .get('https://blog.zee.nl/wp-json/wp/v2/pages')
          .then(response => {
            context.commit('SET_PAGES', response.data)
          })
          .catch(e => {
            reject(e)
          })
          .finally(x => {
            context.commit('SET_LOADING_FALSE')
            context.commit('SET_LOAD_COUNT')
          })
      })
    },
    fetchData (context) {
      context.dispatch('fetchCatalogs')
      context.dispatch('fetchClients')
      context.dispatch('fetchProjects')
      context.dispatch('fetchOptions')
      context.dispatch('fetchPages')
    }
  },
  modules: {
  }
})
